import { getJsonOrError } from './../../utils/fetch'
import { get as getFromPdo } from './../../application/pageDataObject'

const ACTION_COUNTER_PDO_BASE_KEY = 'config.action_counter'
export const NO_HOST = null

let actionProviderHosts = null

let fetchPromise = null

function getFetchUrlByKeys(keys) {
  const hosts = getActionProviderHosts()
  const { READER_ACTION_PROVIDER: baseUrl } = hosts
  const serializedKeys = keys.map(k => `key=${k}&`).join('')
  return `//${baseUrl}/get?${serializedKeys}`
}

export function fetchCounters(keys) {
  const url = getFetchUrlByKeys(keys)
  return (fetchPromise = fetchPromise || getJsonOrError(url))
}

//Fetch without dependency for other promises to be resolved (see: 'fetchCounters' above)
export function fetchCountersIndependent(key) {
  const url = getFetchUrlByKeys([key])
  return getJsonOrError(url)
}

export function getActionProviderHosts() {
  if (actionProviderHosts) {
    return actionProviderHosts
  }

  const [WRITER_ACTION_PROVIDER, READER_ACTION_PROVIDER] = ['host', 'slave'].map(
    i => getFromPdo(`${ACTION_COUNTER_PDO_BASE_KEY}.${i}`),
    NO_HOST
  )
  actionProviderHosts = { READER_ACTION_PROVIDER, WRITER_ACTION_PROVIDER }
  return actionProviderHosts
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/actionCounter/actionCounterBaseProvider.js